export default {
	er_cover_default_title: 'סקירת ביצועים',
	er_page_success_metrics: 'מה השתנה החודש',
	er_page_success_metrics_range: 'מה השתנה בתקופה הזו',
	er_page_success_metrics_week: 'מה השתנה השבוע',
	er_page_comparison: 'סיכום השוואתי',
	er_page_period_summary: 'סיכום החודש',
	er_page_period_summary_range: 'סיכום התקופה',
	er_page_period_summary_week: 'סיכום השבוע',
	er_page_each_month: 'כל חודש',
	er_page_rooms: 'חדרים',
	er_rooms_note: 'כל חדר ב{month}, הציון הגבוה ביותר ראשון.',
	er_page_shift_comparison: 'השוואה לפי משמרת',
	er_page_shift_summary: 'לפי משמרת',
	er_page_response_time: 'זמן תגובה ממוצע (דקות)',
	er_page_avg_score: 'ציון חוויה',
	er_page_complaints_vs_visits: 'תלונות מול ביקורים',
	er_page_performance_trends: 'מגמות ביצועים',
	er_page_complaint_drivers: 'גורמי תלונות',

	er_board_working: 'השתפר לעומת {month}',
	er_board_attention: 'דורש תשומת לב לעומת {month}',
	er_board_empty: 'אין שינויים מהותיים החודש.',
	er_board_empty_range: 'אין שינויים מהותיים בתקופה הזו.',
	er_board_empty_week: 'אין שינויים מהותיים השבוע.',
	er_findings_intro: 'בהשוואה ל־{month}. מוצגים רק שינויים מהותיים.',
	er_verdict_improved: 'השתפר',
	er_verdict_watch: 'דורש תשומת לב',

	er_col_metric: 'מדד',
	er_col_avg: 'ממוצע מתחילת השנה',
	er_col_lifetime_avg: 'ממוצע מתחילת הפעילות',
	er_comparison_note: 'ממוצע מתחילת השנה הוא הנתון מינואר עד {month}.',
	er_lifetime_note: 'ממוצע מתחילת הפעילות הוא הנתון מהיום הראשון עם נתונים עד {month}.',
	er_comparison_note_week: 'שבוע הדוח מושווה לשבוע הקודם שנבחר.',
	er_period_only_note: 'הנתונים הם עבור {month} בלבד.',
	er_each_month_note: 'כל חודש בתקופה שנבחרה. חודש בלי נתונים נשאר ריק.',
	er_col_inc_dec: 'שינוי',
	er_col_complaint: 'תלונה',
	er_col_qty: 'כמות',
	er_total: 'סה"כ',

	er_metric_avg_score: 'ציון חוויה',
	er_metric_avg_response_time: 'זמן תגובה ממוצע',
	er_metric_cleaner_arrivals: 'הגעות מנקים',
	er_metric_supervisor_inspections: 'ביקורות מפקחים',
	er_metric_complaints_vs_visits_pct: 'תלונות מול ביקורים (%)',
	er_metric_complaints: 'תלונות',
	er_metric_customer_visits: 'ביקורים',
	er_metric_expired_slas: 'חריגות SLA',
	er_unit_min: 'דק׳',
	er_stat_expected_sla: 'SLA צפוי',
	er_stat_vs_minutes: 'לעומת {value} ב{month}',
	er_stat_vs_count: 'לעומת {value} ב{month}',
	er_label_complaints: 'תלונות',
	er_label_visits: 'ביקורים',
	er_label_complaints_per_visits: 'תלונות / ביקורים',
	er_chart_ratio: 'יחס תלונות לביקורים',
	er_chart_ytd_window: 'ינואר עד {month}.',
	er_cv_formula: 'תלונות חלקי ביקורים בשירותים, באחוזים: ({complaints} ÷ {visits}) × 100 = {ratio}% ב{month}.',
	er_export_kpis_title: 'מה כלול בדוח',
	er_export_kpis_desc: 'כל אלה נכללים בדוח. כבו מדד כדי להשאיר אותו בחוץ.',
	er_export_select_all: 'בחר הכול',
	er_export_clear_all: 'נקה הכול',
	er_export_summary: '{report} מול {compare}',
	er_export_period_title: 'תקופת הדוח',
	er_export_grain: 'דוח לפי',
	er_export_grain_month: 'חודש',
	er_export_grain_week: 'שבוע',
	er_export_week_starts: 'השבוע מתחיל ב',
	er_export_week_starts_sunday: 'יום ראשון',
	er_export_week_starts_monday: 'יום שני',
	er_export_report_month: 'חודש הדוח',
	er_export_from_month: 'מחודש',
	er_export_to_month: 'עד חודש',
	er_export_period_note_range: 'הדוח מסכם כל חודש מההתחלה ועד הסוף. כשההשוואה פעילה, היא מול התקופה הקודמת באותו אורך. נתוני מתחילת השנה עדיין מינואר ועד חודש הסיום.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} מול {compare}',
	er_export_compare_range_note: 'התקופה הקודמת באותו אורך.',
	er_export_report_week: 'שבוע הדוח',
	er_export_compare_month: 'להשוות מול',
	er_export_shift: 'משמרת',
	er_export_shift_all: 'כל המשמרות',
	er_export_no_shifts: 'באתר זה אין משמרות פעילות.',
	er_export_render_failed: 'לא ניתן היה להציג את הדוח כראוי, ולכן הוא לא הורד. רעננו את הדף ונסו שוב.',
	er_export_comparison: 'השוואה',
	er_export_include_previous: 'כלול את התקופה הקודמת',
	er_export_comparison_on: 'פעיל',
	er_export_comparison_off: 'כבוי',
	er_export_no_previous_data: 'אין נתונים לפני התקופה הזו, ולכן אין עם מה להשוות.',
	er_export_compare_previous: 'החודש הקודם',
	er_export_compare_previous_week: 'השבוע הקודם',
	er_export_compare_last_year: 'אותו חודש בשנה שעברה',
	er_export_no_periods: 'נדרש לפחות חודש אחד של נתונים באתר זה כדי לייצא דוח.',
	er_export_no_periods_week: 'נדרש לפחות שבוע אחד של נתונים באתר זה כדי לייצא דוח.',
	er_export_period_note: 'מוצגים רק חודשים עם נתונים. נתוני מתחילת השנה תמיד מינואר ועד חודש הדוח.',
	er_export_period_note_week: 'מוצגים רק שבועות עם נתונים. ההשוואה תמיד מול שבוע מוקדם יותר.',
	er_export_period_note_single_week: 'מוצגים רק שבועות עם נתונים.',

	er_find_response_time_title: 'זמן תגובה ממוצע',
	er_find_response_time_change: 'השתנה מ-{previous} ל-{current} דקות ({change}).',
	er_find_avg_score_title: 'ציון חוויה',
	er_find_score_eased: 'ירד מ-{previous} ל-{current}.',
	er_find_score_improved: 'עלה מ-{previous} ל-{current}.',
	er_find_score_ytd_inline: 'תואם לממוצע מתחילת השנה, {ytd}.',
	er_find_score_ytd_inline_range: 'תואם את הממוצע מינואר עד {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'ממוצע מתחילת השנה: {ytd}.',
	er_find_score_ytd_against_range: 'ממוצע מינואר עד {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'יחס תלונות לביקורים',
	er_find_complaints_ratio_improved: 'השתפר מ-{previous} ל-{current}.',
	er_find_complaints_ratio_rose: 'השתנה מ-{previous} ל-{current}.',

	er_nar_cv_year_improved: 'תלונות הלקוחות ביחס לביקורים בשירותים השתפרו מ-{from} ל-{to} במהלך השנה.',
	er_nar_cv_year_rose: 'תלונות הלקוחות ביחס לביקורים בשירותים עלו מ-{from} ל-{to} במהלך השנה.',
	er_nar_cv_moved: 'תלונות הלקוחות ביחס לביקורים בשירותים השתנו מ-{previous} ל-{current}.',
	er_nar_cv_current: 'תלונות הלקוחות ביחס לביקורים בשירותים עומדות על {current}.',
	er_nar_types_total: 'סך התלונות {total}.',
	er_nar_types_1: 'התלונה המובילה: {a} ({ap}%).',
	er_nar_types_2: 'התלונה המובילה: {a} ({ap}%), ואחריה {b} ({bp}%).',
	er_nar_types_3: 'התלונה המובילה: {a} ({ap}%), ואחריה {b} ({bp}%) ו-{c} ({cp}%).',
	er_find_rooms_slowest: 'חדרים עם זמן התגובה הארוך ביותר החודש: {rooms}.',
	er_find_rooms_slowest_range: 'חדרים עם זמן התגובה הארוך ביותר בתקופה הזו: {rooms}.',
	er_find_rooms_slowest_week: 'חדרים עם זמן התגובה הארוך ביותר השבוע: {rooms}.',
	er_find_rooms_lowest_score: 'החדרים עם הציון הנמוך ביותר החודש: {rooms}.',
	er_find_rooms_lowest_score_range: 'החדרים עם הציון הנמוך ביותר בתקופה הזו: {rooms}.',
	er_find_rooms_lowest_score_week: 'החדרים עם הציון הנמוך ביותר השבוע: {rooms}.',

	er_find_so_what_ratio: 'רוב השינוי הגיע מ-{rooms}.',
	er_find_so_what_type: 'התלונה המובילה: {name} ({percent}%).',
	er_hot_slowest: 'חדרים עם זמן התגובה הארוך ביותר',
	er_hot_expired_slas: 'חדרים שחרגו מה-SLA',
	er_hot_ratio: 'חדרים עם השינוי הגדול ביותר בשיעור התלונות',
	er_hot_top_type: 'חדרים עם הכי הרבה תלונות מסוג "{name}"',
	er_hot_col_room: 'חדר',
	er_col_response: 'תגובה',
	er_col_cleaners: 'מנקים',
	er_col_score: 'ציון',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'יחס',
	er_hot_col_change: 'שינוי',
	er_hot_col_count: 'כמות',
	er_hot_empty: 'אין הדגשות ברמת חדר החודש.',
	er_hot_empty_range: 'אין הדגשות ברמת חדר בתקופה הזו.',
	er_hot_empty_week: 'אין הדגשות ברמת חדר השבוע.',
	er_cover_highlights: 'החודש',
	er_cover_highlights_range: 'התקופה הזו',
	er_cover_highlights_week: 'השבוע',
	er_cover_score_rose: 'ציון החוויה עלה.',
	er_cover_score_eased: 'ציון החוויה ירד.',
	er_cover_response_improved: 'זמן התגובה השתפר.',
	er_cover_response_slowed: 'זמן התגובה התארך.',
	er_cover_ratio_fell: 'יחס התלונות לביקורים ירד.',
	er_cover_ratio_rose: 'יחס התלונות לביקורים עלה.',
	er_export_pdf: 'PDF של הדשבורד',
	er_export_executive: 'דוח ניהולי',
	'executive-report': 'דוח ניהולי',
	er_export_csv: 'CSV',
	er_export_status_title: 'מפיקים את הדוח',
	er_export_status_fetch: 'טוענים את הנתונים',
	er_export_status_layout: 'מסדרים את העמודים',
	er_export_status_page: 'עמוד {page} מתוך {total}',
	er_footer_copyright: 'דוח זה הופק באמצעות מערכת BuzzzTech.',
	er_contact_line: 'יש שאלות או רוצים להעמיק בנתונים? פנו לצוות ההצלחה של באזזז-טק: {email} או {phone}.',
};
